export default __webpack_public_path__ + "static/media/unipac.59755da9.png";